const YoutubeIcon = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 26 20"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.6249 4.83506C25.5049 3.90506 25.1649 3.02506 24.6249 2.26506C23.9449 1.57506 23.0149 1.18506 22.0549 1.17506C18.3949 0.935058 13.0049 0.935059 13.0049 0.935059C13.0049 0.935059 7.61488 0.935058 4.00488 1.17506C3.03488 1.17506 2.10488 1.56506 1.43488 2.26506C0.884875 3.02506 0.544876 3.90506 0.434875 4.83506C0.254875 6.22506 0.164897 7.61506 0.144897 9.01506V10.9851C0.154897 12.3851 0.234888 13.7751 0.384888 15.1651C0.504888 16.0951 0.844888 16.9751 1.38489 17.7351C2.17489 18.4351 3.18487 18.8251 4.24487 18.8251C6.29487 19.0251 13.0049 19.0651 13.0049 19.0651C13.0049 19.0651 18.3949 19.0651 22.0049 18.7851C22.9749 18.7851 23.9049 18.3951 24.5749 17.7051C25.1249 16.9451 25.4649 16.0651 25.5749 15.1351C25.7449 13.7451 25.8449 12.3551 25.8549 10.9551V8.98506C25.8649 6.93506 25.6249 4.84506 25.6249 4.84506V4.83506ZM10.3449 13.3151V6.07506L17.2949 9.69506L10.3449 13.3151Z"
        fill="inherit"
      />
    </svg>
  )
}
export default YoutubeIcon
